import { render, staticRenderFns } from "./rate-details.vue?vue&type=template&id=fcc12484&scoped=true&"
import script from "./rate-details.vue?vue&type=script&lang=js&"
export * from "./rate-details.vue?vue&type=script&lang=js&"
import style0 from "./rate-details.vue?vue&type=style&index=0&id=fcc12484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc12484",
  null
  
)

export default component.exports